module.exports = __webpack_public_path__ + "static/equipe-90ea95caff69c332a731b51f9bd9e433.png";